import { DefaultService } from '@/services/DefaultService';


export default class AssFormaRecebimentoEmpresaService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAllVendas(column, order, page, limit, situacao, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/empresa/assformarecebimento.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idempresa=${idempresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAllAgro(column, order, page, limit, situacao, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/agro/empresa/assformarecebimento.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idempresa=${idempresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    updateSituacaoVendas(assformarecebimentoempresa) {
        return this._http.post(`${this._env}/ven/empresa/assformarecebimento/updatesituacao`, assformarecebimentoempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoAgro(assformarecebimentoempresa) {
        return this._http.post(`${this._env}/agro/empresa/assformarecebimento/updatesituacao`, assformarecebimentoempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findNaoAssociadosVendas(column, order, page, limit, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/empresa/assformarecebimento/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idempresa=${idempresa}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findNaoAssociadosAgro(column, order, page, limit, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/agro/empresa/assformarecebimento/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idempresa=${idempresa}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveVendas(lista) {
        return this._http.post(`${this._env}/ven/empresa/assformarecebimento`, lista, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAgro(lista) {
        return this._http.post(`${this._env}/agro/empresa/assformarecebimento`, lista, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}